export default __webpack_public_path__ + "static/media/midasi_entry_vi_pc@2x.fa246803.png";